module.exports = __webpack_public_path__ + "static/media/ax.1aaab703.svg";